module.exports = __webpack_public_path__ + "img/service.c450b364.svg";